<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import { confirm } from '../../components/confirm.js'
  import { Button } from '../../components/ui'

  let { sub_categories = [] } = $props()

  const archive = async (item) => {
    const confirmed = await confirm({
      title: 'Confirm Archive',
      variant: 'error',
      body: 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!confirmed) return
    router.delete(`/categories/${item.id}`, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="Categories" subtitle="Sub-categories used to group campaigns and places" count={sub_categories.length}>
    {#snippet actions()}
      <Button href="/categories/new" variant="primary" size="sm" icon="add">New Category</Button>
    {/snippet}
  </PageHeader>

  <EntityList entity="category" rows={sub_categories} onDelete={archive} />
</Layout>
